export enum ServiceSessionEventType {
  CREATED = 'session.created',
  DELIVERED = 'session.delivered',
  REJECTED = 'session.rejected',
  HANGUP = 'session.hangup',
  OFFERED = 'session.offered',
  RESCINDED = 'session.rescinded',
  WRAPUP_COMPLETED = 'sessionsession.wrapup.completed',
  WRAPUP_STARTED = 'session.wrapup.started',
  DELETED = 'session.deleted',
}

export type ServiceSessionEvent = {
  sessionId: string;
  sessionSid: string;
};

export type ServiceSessionUserEvent = ServiceSessionEvent & {
  userId: string;
  agentId: string;
};

export type ServiceSessionCreatedEvent = ServiceSessionEvent & {
  from: string;
  displayName: string;
  tenantId: string;
};

export type ServiceSessionOfferedEvent = ServiceSessionUserEvent & {
  from: string;
  displayName: string;
  tenantId: string;
  queueName: string;
  queueId: string;
  queueEnterTime: string;
};

export type ServiceSessionWrapupEvent = ServiceSessionUserEvent & {
  timestamp: string;
  wrapupAllowedMs: number;
};

export default [
  ServiceSessionEventType.CREATED,
  ServiceSessionEventType.DELIVERED,
  ServiceSessionEventType.REJECTED,
  ServiceSessionEventType.HANGUP,
  ServiceSessionEventType.OFFERED,
  ServiceSessionEventType.RESCINDED,
  ServiceSessionEventType.WRAPUP_COMPLETED,
  ServiceSessionEventType.WRAPUP_STARTED,
  ServiceSessionEventType.DELETED,
];
